import {createLazyFileRoute} from '@tanstack/react-router'

import SignUp from '@/views/auth/SignUp/SignUp'

export const Route = createLazyFileRoute('/auth/sign-up')({
  component: SignUp,
})
